import moment from "moment";
import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
//ICONS
import ActivatedIcon from "./../../../Assets/images/activated.svg";
import Header from "../../../Components/Header/Header";
import PlusIcon from "./../../../Assets/images/plus_1.svg";
import CloseIcon from "./../../../Assets/images/minus_1.svg";
import SearchIcon from "../../../Assets/images/search.svg";
import CloseIconNew from "../../../Assets/images/close.svg";
// CONTEXT
import { AppContext } from "../../../Context/AppContext";
import { CMS_MENU_ADD_DEPTH, CMS_MENU_EDIT_DEPTH, CMS_MENU_MODULES, MODULES } from "./../../../Helpers/Constants";
import { getAccessByModuleName } from "./../../../Routes/Routes";
//API
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { addLocationMenu, getCmsMenuList, setMenuSchedule, updateLocationMenu } from "api/cmsMenu";
import { updateStatus } from "../../../api/utils";
//CSS
import styles from "./index.module.scss";
//COMPONENT
import StatusConfirmation from "../../../Components/Modal/StatusConfirmation/StatusConfirmation";
import NestableSortable from "../../../Components/NestableSortable";
import Select from "../../../Components/FormControl/Select/Select";

// Details Image
import ViewProductList from "./../../../Assets/images/View_product_list_1.svg";
import AddIcon from "./../../../Assets/images/add.svg";
import EditIcon from "./../../../Assets/images/edit.svg";
import AddLocationMenu from "Components/Modal/AddLocationMenu/AddLocationMenu";

const MenuManagement = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { showToastMessage, setIsLoading, modules } = useContext(AppContext);

  const [data, setData] = React.useState([]);

  const [access, setAccess] = useState({});
  const [statusMenuId, setStatusMenuId] = useState(false);
  const [statusOfMenu, setStatusOfMenu] = useState();
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [schedule, setSchedule] = useState(null);
  const saving = useRef(false);
  const [showAddLocationMenu, setShowAddLocationMenu] = useState(false);
  const [menuData, setMenuData] = useState({});
  const [submitStatus, setSubmitStatus] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [locationParentId, setLocationParentId] = useState(0);  

  const [menuForFilter, setMenuForFilter] = React.useState("web");
  const menuFilterData = [
    { id: "web", title: "Web" },
    { id: "mobile", title: "Mobile" },
    { id: "admin", title: "Admin" },
  ];

  const [menuPosition, setMenuPosition] = React.useState("TOP");
  const menuPositionData = [
    { id: "TOP", title: "Top" },
    { id: "LEFT", title: "Left" },
    { id: "RIGHT", title: "Right" },
    { id: "LEFT-BOTTOM", title: "Left Bottom" },
    { id: "BOTTOM", title: "Bottom" },
    { id: "CENTER", title: "Center" },
  ];

  useEffect(getModuleAccess, [modules]);
  useEffect(() => {
    fetchData(defaultFilter);
  }, []);

  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.MENU);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate("/users");
    }
  }

  const [defaultFilter, setDefaultFilter] = useState({
    menuFor: "web",
    position: "TOP",
  });

  const fetchData = async (filterData) => {
    setIsLoading(true);
    let postData;
    if (filterData && filterData !== undefined) {
      postData = {
        menuFor: filterData.menuFor ?? menuForFilter,
        position: filterData.position ?? menuPosition,
      };
    } else {
      postData = {
        menuFor: menuForFilter,
        position: menuPosition,
      };
    }

    const response = await getCmsMenuList(postData);
    if (response && response.status === 200) {
      setData(response.data.data);
      // setPageCount(Math.ceil(response.data.data.count / pageSize));
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
  };

  const handleStatusMenuClick = async (event, id, status) => {
    event.preventDefault();

    setStatusMenuId(id);
    setStatusOfMenu(status);
    setShowStatusModal(true);
  };

  const saveSchedule = async (clear) => {
    const { id, activate_on, deactivate_on, expected_activate_on, expected_deactivate_on } = schedule;
    if (saving.current) return;
    saving.current = true;
    const response = await setMenuSchedule({
      id,
      activate_on: clear ? null : activate_on || null,
      deactivate_on: clear ? null : deactivate_on || null,
      expected_activate_on,
      expected_deactivate_on,
    }).finally(() => {
      saving.current = false;
    });
    if (response && response.status === 200) {
      setSchedule(null);
      showToastMessage(undefined, "Schedule saved", "success", false);
      fetchData();
    } else {
      showToastMessage(undefined, response?.data?.message || "Could not save the schedule", "error", false);
      if (response?.status === 409) {
        setSchedule(null);
        fetchData();
      }
    }
  };

  const handleMenuStatus = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    let postData = {
      status: statusOfMenu === 1 ? 0 : 1,
      id: statusMenuId,
      table: "menu_masters",
    };

    // const response = await utilsService.updateStatus(postData);
    const response = await updateStatus(postData);
    if (response && response.status === 200) {
      setStatusMenuId(null);
      setStatusOfMenu(null);
      setShowStatusModal(false);
      showToastMessage(undefined, response.data.message, "success", false);

      let tempFilter = {
        menuFor: menuForFilter ?? "web",
        position: menuPosition ?? "TOP",
      };

      fetchData(tempFilter);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }

    setIsLoading(false);
  };

  const handleClearSearch = async (event) => {
    event.preventDefault();
    setMenuForFilter("web");
    setMenuPosition("TOP");

    fetchData(defaultFilter);
  };

  // Handle Menu/SubMenu Details Page
  const handleMenuSubMenuDetailsPage = (id) => {
    navigate("/cms/menu/sequence/" + id);
  };

  
  // Resolve the effective child module for an add: a parent may itself be a
  // valid module (e.g. "locations") or be a container (e.g. Collections with
  // an empty module) whose children carry the module type.
  const getAddModule = (item) => {
    if (item?.module && CMS_MENU_MODULES.includes(item.module)) return item.module;
    const child = item?.children?.find((c) => CMS_MENU_MODULES.includes(c.module));
    return child?.module ?? "";
  };

  const handleAddMenuClick = (e, item) => {
    e.preventDefault();
    setShowAddLocationMenu(true);
    setMenuData(item || {});
  };

  const handleEditMenuClick = (e, item) => {
    e.preventDefault();

    setShowAddLocationMenu(true);
    setMenuData(item || {});

    // Find parent menu data with null check
    const parentMenuData = data.find(menu => menu.id === item?.main_parent_id);

    if (parentMenuData && parentMenuData.children && Array.isArray(parentMenuData.children)) {
      const secondHierarchyMenuData = parentMenuData.children.find(menu => menu.id === item?.parent_id);
      setLocationParentId(secondHierarchyMenuData?.module_id || 0);
    } else {
      setLocationParentId(0);
    }

    setIsEdit(true);
  };

  // Handles the submission of a new location menu item
  const handleSubmitClick = async (values)=>{
    setIsLoading(true);
    setSubmitStatus(true);
    if(isEdit){
      const postData = { 
        ...menuData,
        module_id: values.module_id,
        slug: values.slug,
        status: values.status,
        title: values.title,
      }
       // Make API call to update the location menu
       const response = await updateLocationMenu(postData);
       if (response && response.status === 200) {
         showToastMessage(undefined, response.data.message, "success", false);
         setShowAddLocationMenu(false);
       } else {
         showToastMessage(undefined, response.data.message, "error", false);
         setShowAddLocationMenu(false);
       }
    } else  {
      // Calculate the sequence number based on existing children
      const sequence = (menuData?.children?.length || 0) + 1;
      // Prepare data for API submission by combining form values with parent menu data
      const postData = {
          ...values,
          menu_for: menuData?.menu_for,      // Type of menu (web/mobile/admin)
          module: getAddModule(menuData),    // Module this menu belongs to
          parent_id: menuData?.id || null,   // Direct parent menu ID
          main_parent_id:  menuData?.main_parent_id ? menuData?.main_parent_id : menuData?.id,  // Top-level parent menu ID
          position: menuData?.position || null,  // Menu position (TOP/LEFT/RIGHT etc)
          sequence: sequence,                   // Order in the menu hierarchy
      }
      // Make API call to add the new location menu
      const response = await addLocationMenu(postData);
      if (response && response.status === 200) {
        showToastMessage(undefined, response.data.message, "success", false);
        setShowAddLocationMenu(false);
      } else {
      showToastMessage(undefined, response.data.message, "error", false);
      setShowAddLocationMenu(false);
      }
    }
    // Reset loading and submit states
    setIsLoading(false);
    setSubmitStatus(false);
    setIsEdit(false);
    setLocationParentId(0);
    // Refresh the menu list
    fetchData();
  }

  const renderItem = ({ collapseIcon, depth, handler, index, item }) => (
    <div className={styles.GridTable}>
      <div
        className={
          "d-flex align-items-center justify-cotent-between cursor-pointer ml-3"
        }
      >
        {collapseIcon}
      </div>
      <div>{item.title}</div>
      <div>{item.module}</div>
      <div className={styles.status}>
        {item.status === 1 ? (
          <div className={styles.Active}>Active</div>
        ) : (
          <div className={styles.Inactive}>Inactive </div>
        )}
      </div>

      <div
        className={access && access.write_access ? "link cursor-pointer" : ""}
        onClick={() => access && access.write_access && setSchedule({
          ...item,
          expected_activate_on: item.activate_on ?? null,
          expected_deactivate_on: item.deactivate_on ?? null,
        })}
      >
        {[item.activate_on && `On ${moment(item.activate_on).format("MMM D, YYYY")}`,
          item.deactivate_on && `Off ${moment(item.deactivate_on).format("MMM D, YYYY")}`]
          .filter(Boolean).join("; ") || (access && access.write_access ? "Schedule..." : "")}
      </div>

      <div className={styles.CreatedRow}>
        {moment(item.createdAt).format("ddd MMM DD, YYYY")}
      </div>
      <div className={styles.UpdateRow}>
        {moment(item.updatedAt).format("ddd MMM DD, YYYY")}
      </div>
      <div>
        {access && access.write_access && (
          <img
            className={`cursor-pointer ml-3`}
            src={ActivatedIcon}
            alt="Active"
            onClick={(e) => handleStatusMenuClick(e, item.id, item.status)}
          />
        )}
        {access && access.write_access && item?.children && Array.isArray(item.children) && item.children.length > 0 && (
          <span className={`link cursor-pointer ml-2`}>
            <img
              className={`cursor-pointer`}
              src={ViewProductList}
              style={{
                height: "38px",
              }}
              alt="Add"
              onClick={(e) => {
                e.preventDefault();
                handleMenuSubMenuDetailsPage(item.id);
              }}
            />
          </span>
        )}
        {/* Provde plus icon for add new menu */}
        {access && access.write_access &&
          (CMS_MENU_MODULES.includes(item.module) ||
            item?.children?.some((c) => CMS_MENU_MODULES.includes(c.module))) &&
          CMS_MENU_ADD_DEPTH.includes(depth) && (
          <span
            className={`link cursor-pointer ml-2 ${styles.iconWrapper}`}
            onClick={(e) => handleAddMenuClick(e, item)}
          >
            <img className={`cursor-pointer`} src={AddIcon} alt="Add" />
          </span>
        )}

        {/* Provide edit icon for edit menu */}
        {access && access.write_access &&  
          CMS_MENU_MODULES.includes(item.module) && 
          CMS_MENU_EDIT_DEPTH.includes(depth) && (
          <span className={`cursor-pointer ml-3`} 
            onClick={(e) => handleEditMenuClick(e, item)}
          >
            <img className={`cursor-pointer`} src={EditIcon} alt="Edit" />
          </span>
        )}
      </div>
    </div>
  );

  const renderCollapseIcon = ({ isCollapsed, item }) => (
    <img
      className="cursor-pointer mr-2"
      style={{ width: "25px", height: "25px" }}
      src={isCollapsed ? PlusIcon : CloseIcon}
      alt="Collapse"
    />
  );

  return (
    <React.Fragment>
      <Header title="CMS - Menu" />
      <div id="MainContent" className="main-content" />
      <div className="row mb-5">
        <div className="col-md-4">
          <Select
            label="Menu For"
            value={menuForFilter}
            options={menuFilterData}
            required={false}
            onChange={(data) => setMenuForFilter(data)}
            disabled={false}
          />
        </div>
        <div className="col-md-4">
          <Select
            label="Menu Position"
            value={menuPosition}
            options={menuPositionData}
            onChange={(data) => setMenuPosition(data)}
            disabled={false}
          />
        </div>
        <div className="col-sm-2 col-xs-12">
          <div className="td-actions pt-4">
            <span
              onClick={(e) => fetchData()}
              className={`link cursor-pointer ${styles.searchIconWrapper}`}
            >
              <img className={styles.searchIcon} src={SearchIcon} alt="" />
            </span>
            <span
              onClick={(e) => handleClearSearch(e)}
              className={`link cursor-pointer ml-3 ${styles.clearIconWrapper}`}
            >
              <img className={styles.clearIcon} src={CloseIconNew} alt="" />
            </span>
          </div>
        </div>
      </div>
      <div className={styles.GridTable}>
        <div className={styles.MoveButton}></div>
        <div>Name</div>
        <div>Module</div>
        <div>Status</div>
        <div>Schedule</div>
        <div>Created At</div>
        <div>Updated At</div>
        <div className={styles.Actions}></div>
      </div>
      {data.length !== 0 ? (
        <NestableSortable
          className={styles.NestedGroup}
          items={data}
          renderItem={renderItem}
          renderCollapseIcon={renderCollapseIcon}
          maxDepth={10}
        />
      ) : (
        "No data found"
      )}

      {access.write_access && (
        <StatusConfirmation
          showModal={showStatusModal}
          title={"Menu"}
          message={"menu?"}
          buttonLabel={statusOfMenu ? "Inactivate" : "Activate"}
          statusFlag={statusOfMenu}
          customFlag={false}
          handleCancelClick={(event) => {
            event.preventDefault();
            setShowStatusModal(false);
            statusMenuId(null);
            statusOfMenu(null);
          }}
          handleSubmitClick={handleMenuStatus}
        />
      )}

    <Dialog open={!!schedule} onClose={() => setSchedule(null)}>
      <DialogContent className="text-center">
        <h5 className="my-3">Schedule "{schedule?.title}"</h5>
        {[["activate_on", "Turn on date"], ["deactivate_on", "Turn off date"]].map(([key, label]) => (
          <label key={key} className="d-block mb-3">
            {label}
            <input
              type="date"
              className="form-control"
              value={schedule?.[key] ?? ""}
              onChange={(e) => setSchedule({ ...schedule, [key]: e.target.value })}
            />
          </label>
        ))}
        <button type="button" className="btn gray-btn mr-2" onClick={() => saveSchedule(false)}>Save</button>
        <button type="button" className="btn gray-btn" onClick={() => saveSchedule(true)}>Clear</button>
      </DialogContent>
    </Dialog>

    {access.write_access && showAddLocationMenu && (
      <AddLocationMenu
        showModal={showAddLocationMenu}
        handleCancelClick={() => {
          setShowAddLocationMenu(false);
          setIsEdit(false);
          setLocationParentId(0);
        }}
        pageTitle={isEdit ? "Edit Location Menu" : "Add Location Menu"}
        menuData={menuData}
        handleSubmitClick={handleSubmitClick}
        submitStatus={submitStatus}
        isEdit={isEdit}
        locationParentId={locationParentId}
        module={getAddModule(menuData)}
      />
    )}
      
    </React.Fragment>
  );
};

export default MenuManagement;
